import React, { Component } from "react";
import { formatDate } from "../../../../utils/utils";
import { Badge } from "react-bootstrap";
import NumberFormat from "react-number-format";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { getSalesOrders } from "../../../../services/sales/salesOrderService";
import withGlobalData from "../../common/withGlobalData";
class SearchSalesOrder extends Component {
  state = { reload: this.props.globalData.reload, salesOrders: [] };

  componentDidMount() {
    this.getSalesOrders();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getSalesOrders();
      this.setState({ reload: globalData.reload });
    }
  }

  async getSalesOrders() {
    const { giStatus, reserveStatus } = this.props;
    const response = await getSalesOrders(giStatus, reserveStatus);
    const { data } = response.data;
    this.setState({ open: false, salesOrders: data.salesOrders });
  }

  render() {
    const { salesOrders } = this.state;
    const { showAmount = true, onSelectSalesOrder } = this.props;
    return (
      <CustomDataTableSearch
        data={salesOrders}
        onRefreshData={() => {
          this.getSalesOrders();
        }}
        onSelectedData={(rowData, originalEvent) => {
          onSelectSalesOrder(rowData);
        }}
        columns={[
          {
            field: "select",
            body: (rowData) => (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-success btn-sm btn-pill btn-bold"
                  onClick={() => onSelectSalesOrder(rowData)}
                >
                  Select <i className="fas fa-angle-double-right"></i>
                </button>
              </React.Fragment>
            ),
          },
          {
            header: "Sales Order ID",
            field: "salesOrderCode",
            body: null,
            sortable: true,
          },
          {
            header: "Customer Name",
            field: "customer.customerName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis
                  text={rowData.customer.customerName}
                  maxLine="1"
                />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "Order Date",
            field: "orderDate",
            body: (rowData) => formatDate(rowData.orderDate),
            sortable: true,
          },
          {
            header: "Goods Issue Status",
            field: "giStatusDesc",
            body: (rowData) => {
              if (rowData.giStatus === 1) {
                return <Badge variant="danger">{rowData.giStatusDesc}</Badge>;
              } else if (rowData.giStatus === 2) {
                return <Badge variant="warning">{rowData.giStatusDesc}</Badge>;
              } else if (rowData.giStatus === 3) {
                return <Badge variant="success">{rowData.giStatusDesc}</Badge>;
              } else {
                return <Badge variant="dark">{rowData.giStatusDesc}</Badge>;
              }
            },
            sortable: true,
          },
          {
            header: "Invoice Status",
            field: "invoiceStatusDesc",
            body: (rowData) => {
              if (rowData.invoiceStatus === 1) {
                return (
                  <Badge variant="danger">{rowData.invoiceStatusDesc}</Badge>
                );
              } else if (rowData.invoiceStatus === 2) {
                return (
                  <Badge variant="warning">{rowData.invoiceStatusDesc}</Badge>
                );
              } else if (rowData.invoiceStatus === 3) {
                return (
                  <Badge variant="success">{rowData.invoiceStatusDesc}</Badge>
                );
              } else {
                return (
                  <Badge variant="dark">{rowData.invoiceStatusDesc}</Badge>
                );
              }
            },
            sortable: true,
          },
          {
            header: "Currency",
            field: "currency.currencyCode",
            body: null,
            sortable: true,
            filter: true,
            hidden: true,
          },
          {
            header: "Grand Total",
            field: "grandTotal",
            body: (rowData) => (
              <NumberFormat
                value={rowData.grandTotal}
                displayType={"text"}
                thousandSeparator={true}
                decimalScale={2}
                renderText={(value) => (
                  <div className="float-right">
                    {rowData.currency.currencyCode} {value}
                  </div>
                )}
              />
            ),
            sortable: true,
          },
        ]}
      />
    );
  }
}

export default withGlobalData(SearchSalesOrder);
